import RelatedItems from './components/RelatedItems';
import { HasFieldCondition } from './helpers/slotConditions';

const registerSlotComponents = (config) => {
  // ==================
  // aboveFooter
  // ==================

  // Itens relacionados
  config.registerSlotComponent({
    slot: 'belowContent',
    name: 'relatedItems',
    component: RelatedItems,
    predicates: [HasFieldCondition('relatedItems')],
  });

  return config;
};

export default registerSlotComponents;
